import * as React from 'react';

import TestCasePill from 'bundles/author-code-evaluator/components/TestCasePill';
import type EvaluatorTestCaseRunner from 'bundles/author-code-evaluator/models/EvaluatorTestCaseRunner';
import Modal from 'bundles/author-common/components/Modal';
import type Evaluation from 'bundles/code-evaluator/models/Evaluation';

import _t from 'i18n!nls/author-code-evaluator';

import 'css!bundles/author-code-evaluator/components/__styles__/TestCaseRunner';

type State = {
  currentTestCaseIndex: number;
};

type Props = {
  evaluation: Evaluation;
  handleRun: (expression: string) => void;
  onCancel: () => void;
  onChange: (index: number, testCase: EvaluatorTestCaseRunner) => void;
  onClose: () => void;
  testCaseRunners: Array<EvaluatorTestCaseRunner>;
};

class TestCaseRunner extends React.Component<Props, State> {
  constructor(props: Props, context: any) {
    super(props, context);

    this.state = {
      currentTestCaseIndex: -1,
    };
  }

  UNSAFE_componentWillMount() {
    this.runNextTestCase();
  }

  UNSAFE_componentWillReceiveProps(newProps: Props) {
    if (this.props.evaluation !== newProps.evaluation && newProps.evaluation.response != null) {
      const { response } = newProps.evaluation;
      const latestEvaluationId = newProps.evaluation.response.id;

      const testCase = newProps.testCaseRunners[this.state.currentTestCaseIndex];
      // @ts-expect-error TS18048 Unchecked index access, value is possibly undefined see https://www.typescriptlang.org/tsconfig/#noUncheckedIndexedAccess
      const copy = testCase.copy();

      copy.testCase.latestEvaluationId = latestEvaluationId;
      copy.response = response;

      this.props.onChange(this.state.currentTestCaseIndex, copy);

      this.runNextTestCase();
    }
  }

  handleCancel = () => {
    this.props.onCancel();
    this.props.onClose();
  };

  runNextTestCase = () => {
    const { onClose, handleRun, testCaseRunners } = this.props;
    const { currentTestCaseIndex } = this.state;

    const nextTestCaseRunner = testCaseRunners.find((testCase, index) => index > currentTestCaseIndex);

    if (nextTestCaseRunner == null) {
      onClose();
    } else {
      const nextTestCaseIndex = testCaseRunners.indexOf(nextTestCaseRunner);
      this.setState({
        currentTestCaseIndex: nextTestCaseIndex,
      });

      handleRun(nextTestCaseRunner.testCase.expression);
    }
  };

  render() {
    const { testCaseRunners } = this.props;
    const { currentTestCaseIndex } = this.state;

    return (
      <Modal
        allowClose={false}
        withTitle={true}
        withFooter={true}
        heading={_t('Running test cases')}
        cancelLabel={_t('Cancel')}
        onCancel={this.handleCancel}
        hideConfirm={true}
        className="rc-TestCaseRunner"
      >
        <div>
          {testCaseRunners.map((testCaseEvaluator: EvaluatorTestCaseRunner, index: number) => {
            return (
              <span style={{ marginRight: 20 }} key={index}>
                <TestCasePill
                  name={testCaseEvaluator.testCase.name}
                  onClick={() => {}} // do nothing when selected
                  index={index}
                  isFailed={testCaseEvaluator.isFailed}
                  isPassed={testCaseEvaluator.isPassed}
                  isSelected={index === currentTestCaseIndex}
                />
              </span>
            );
          })}
        </div>
      </Modal>
    );
  }
}

export default TestCaseRunner;
